import { Module } from 'vuex';

export interface Conversation {
  conversationId: string;
  title: string;
  summary: string;
  conversationLength: number;
  isWaitingResponse: boolean;
}

export const askGooverStore: Module<Conversation, any> = {
  namespaced: true,
  state: {
    conversationId: '',
    title: '',
    summary: '',
    conversationLength: 0,
    isWaitingResponse: false,
  },
  getters: {
    getConversationId: state => state.conversationId,
    getConversationTitle: state => state.title,
    getConversationSummary: state => state.summary,
    getConversationLength: state => state.conversationLength,
    getIsWaitingResponse: state => state.isWaitingResponse,
  },
  mutations: {
    setConversationId(state, conversationId) {
      state.conversationId = conversationId;
    },
    setConversationTitle(state, title) {
      state.title = title;
    },
    setConversationSummary(state, summary) {
      state.summary = summary;
    },
    setConversationLength(state, conversationLength) {
      state.conversationLength = conversationLength;
    },
    setIsWaitingResponse(state, isWaitingResponse) {
      state.isWaitingResponse = isWaitingResponse;
    },
  },
  actions: {
    setConversationId: async (context, payload: { conversationId }) => {
      context.commit('setConversationId', payload.conversationId);
      return;
    },
    setConversationTitle: async (context, payload: { title }) => {
      context.commit('setConversationTitle', payload.title);
      return;
    },
    setConversationSummary: async (context, payload: { summary }) => {
      context.commit('setConversationSummary', payload.summary);
      return;
    },
    setConversationLength: async (context, payload: { conversationLength }) => {
      context.commit('setConversationLength', payload.conversationLength);
      return;
    },
  },
};
